module.exports = __webpack_public_path__ + "img/obs_water_refuge.3c6e84dc.svg";